import React from 'react';
import { ENVIRONMENT } from '../../config/environment';

const STYLE = {
  DEV:     { background: 'rgba(245, 158, 11, 0.18)', color: '#fbbf24', border: '1px solid rgba(245, 158, 11, 0.55)' },
  PROD:    { background: 'rgba(220, 38, 38, 0.22)',  color: '#fecaca', border: '1px solid rgba(239, 68, 68, 0.7)' },
  UNKNOWN: { background: 'rgba(148, 163, 184, 0.15)', color: '#cbd5e1', border: '1px solid rgba(148, 163, 184, 0.4)' },
};

/** Always-visible environment pill ("DEV" amber / "PROD" red). `env` is injectable for tests. */
export default function EnvBadge({ env = ENVIRONMENT, className = '' }) {
  return (
    <span
      data-testid="env-badge"
      title={`This admin talks to ${env.host || 'an unknown API'}`}
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-bold tracking-wider ${className}`}
      style={STYLE[env.name] || STYLE.UNKNOWN}
    >
      <span aria-hidden="true" className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: 'currentColor' }} />
      {env.name}
    </span>
  );
}
